<template>
    <div class="kris-documents-box">
      <div class="h2">Локальные акты</div>
      <ul class="kris-doclist" v-if="data">
        <FileV2 v-bind:key="item.hash" v-for="item in data" :info="item"/>
      </ul>
      <sample-notify />
      <coll-agreement />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import CollAgreement from './CollAgreement'
import SampleNotify from './SampleNotify'
import FileV2 from "./FileV2";
export default {
  name: 'LocalDocs',
  components: {
    'FileV2': FileV2,
    'coll-agreement': CollAgreement,
    'sample-notify': SampleNotify
  },
  computed: {
    ...mapState({
      'data': 'dataLocalDocs'
    })
  },
  created () {
    this.$store.dispatch('getDataLocalDocs')
  }
}
</script>

<style scoped>

</style>
